import { initializeApp } from "firebase/app";
import { getDatabase, ref, update } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyArKDLRCOvX1najLuOXqanDSjTtNQLnIuo",
  authDomain: "dazzling-inferno-5869.firebaseapp.com",
  databaseURL: "https://dazzling-inferno-5869.firebaseio.com",
  storageBucket: "dazzling-inferno-5869.appspot.com",
  messagingSenderId: "475798511262",
};

export const COLLECTION_PATH = "wishlist/";

const firebase = initializeApp(firebaseConfig);

const database = getDatabase(firebase);

const wishlistDb = ref(database, COLLECTION_PATH);

const onCheckToggle = (item) => {
  const updatedItem = {
    ...item,
    checked: !item.checked,
  };
  delete updatedItem.id;

  const key = `${COLLECTION_PATH}${item.id}`;
  const updates = {
    [key]: updatedItem,
  };
  console.log("onCheckToggle", updates);

  return update(ref(database), updates);
};

export { wishlistDb, onCheckToggle };
